import { TextCell } from '@common/components/TextCell';

interface RegistrationStateCellProps {
	registrationState?: string;
}

export const RegistrationStateCell = ({ registrationState }: RegistrationStateCellProps) => {
	return <TextCell value={registrationState} />;
};
